const { getExpenses, getCategories, createExpense, updateExpense, deleteExpense } = require('@/controllers/expenses').ct_expenses;

const initialState = () => ({
    expenses: [],
    summary: {},
    pagination: {},
    categories: [],
});

const state = initialState();

const mutations = {
    SET_EXPENSES(state, { data, summary = {}, pagination = {} }) {
        state.expenses = data;
        state.summary = summary;
        state.pagination = pagination;
    },
    SET_CATEGORIES(state, categories) {
        state.categories = categories;
    },
    RESET_EXPENSES_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_expenses(state) {
        return {
            data: state.expenses,
            summary: state.summary,
            pagination: state.pagination,
        };
    },
    // categorias já usadas pela empresa
    get_expense_categories(state) {
        return state.categories;
    },
};

const actions = {
    async load_expenses({ commit }, params = {}) {
        const response = await getExpenses(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_EXPENSES', response);
        return response;
    },

    async load_expense_categories({ commit }) {
        const response = await getCategories();

        if (!response.status) {
            throw response.error;
        }

        commit('SET_CATEGORIES', response.data);
        return response.data;
    },

    // payload: { id?, ...campos }
    async save_expense(_, { id, ...data }) {
        const response = id ? await updateExpense(id, data) : await createExpense(data);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    async remove_expense(_, id) {
        const response = await deleteExpense(id);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
